export default __webpack_public_path__ + "static/media/home.3b8b1017.svg";